import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TextBlockItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-text-block-select-dialog',
  templateUrl: './text-block-select-dialog.component.html',
  styleUrls: ['./text-block-select-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBlockSelectDialogComponent {
  private readonly dialogRef: NbDialogRef<TextBlockSelectDialogComponent> = inject(NbDialogRef);

  @Input() textBlocks: TextBlockItemDto[] = [];

  select(textBlock: TextBlockItemDto): void {
    this.dialogRef.close(textBlock);
  }
}
